import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Bioresonance Leicester';
const DEFAULT_IMAGE = '/logo192.png'; // replace with a real OG image path if you have one

/**
 * Per-page SEO: title, meta description, canonical URL, Open Graph and Twitter tags.
 * @param {string} title - Page title (e.g. "Contact"). Will become "Contact – Bioresonance Leicester".
 * @param {string} description - Meta description for search and sharing.
 * @param {string} path - Canonical path (e.g. "/contact"). Full URL is built from window.location.origin.
 * @param {string} [image] - Optional OG image path (defaults to DEFAULT_IMAGE).
 */
const SEO = ({ title, description, path, image = DEFAULT_IMAGE }) => {
  const fullTitle = title ? `${title} – ${SITE_NAME}` : SITE_NAME;
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://tpwellness.co.uk';
  const canonicalUrl = `${origin}${path || '/'}`.replace(/\/$/, '') || origin;
  const imageUrl = image.startsWith('http') ? image : `${origin}${image.startsWith('/') ? '' : '/'}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_GB" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
